import { render } from "./EmployeeRejectedRequests.vue?vue&type=template&id=0ed1b0a4"
import script from "./EmployeeRejectedRequests.vue?vue&type=script&lang=js"
export * from "./EmployeeRejectedRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__